import { comics } from "@/mocks/comics";
import ComicCard from "./ComicCard";

export default function DailyUpdates() {
  const today = comics.slice(0, 8);

  return (
    <section id="daily" className="border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-500 text-background-50">
              <i className="ri-flashlight-line text-xl" aria-hidden="true"></i>
            </span>
            <div>
              <p className="text-sm font-semibold text-accent-700">今日热更</p>
              <h2 className="mt-0.5 font-heading text-2xl text-foreground-950 md:text-3xl">每日更新</h2>
            </div>
          </div>
          <p className="text-sm text-foreground-600">
            <i className="ri-time-line mr-1" aria-hidden="true"></i>
            今日 12:00 已更新 · 点击卡片即可进入追更
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
          {today.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}